import React from 'react'
import { css } from '@emotion/core'
import { useAtSize, colors } from '@fs/zion-ui'
import { SOLID, GRADIENT, NONE } from './ComparisonPanelBackgroundTypes'

const getGenderColor = (gender) => {
  let color = '#555555'
  if (gender === 'male') {
    color = colors.billboard.blue20
  } else if (gender === 'female') {
    color = colors.billboard.red20
  }
  return color
}

export default function ComparisonPanel({ children, gender, background = SOLID }) {
  const atSize = useAtSize()
  let backgroundStyle
  let borderStyle

  if (background === GRADIENT) {
    backgroundStyle = atSize({
      default: '',
      md: 'background-image: linear-gradient(to top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1));',
    })
  } else if (background === SOLID) {
    backgroundStyle = 'background-color: rgba(0, 0, 0, 0.7);'
  } else if (background === NONE) {
    backgroundStyle = ''
  }

  if (background === SOLID || background === GRADIENT) {
    borderStyle = `
    border-radius: ${atSize({ default: 'none', md: '8px' })};
    border-top: ${atSize({ default: 'none', md: `8px solid ${getGenderColor(gender)}` })};
    `
  }

  const panelStyle = css`
    width: ${atSize({ default: '100%', lg: '49vw' })};
    max-width: 900px;
    margin: ${atSize({ default: '1vw 0', lg: '0 1vw' })};
    display: flex;
    justify-content: center;
    width: 100%;
    flex-direction: ${atSize({ default: 'column', md: 'row' })};
    ${backgroundStyle}
    ${borderStyle}
    padding: 10px;
  `
  return <div css={panelStyle}>{children} </div>
}
